/* ET Subs buy CTA: clears the cart, adds the configured product (with
   selling plan) and goes straight to checkout with the discount applied.

   Uses XMLHttpRequest on purpose: the global-promo gift script in the layout
   monkey-patches window.fetch and auto-adds the free gift to every
   /cart/add POST it sees — XHR bypasses that interceptor, so the trial
   checkout contains only the subscription product. */
(function () {
  if (window.etSubsBuyReady) return;
  window.etSubsBuyReady = true;

  function post(url, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) resolve(xhr);
        else reject(new Error('HTTP ' + xhr.status));
      };
      xhr.onerror = function () { reject(new Error('network error')); };
      xhr.send(body ? JSON.stringify(body) : null);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-et-buy]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.etBuyBusy) return;
    btn.dataset.etBuyBusy = 'true';

    var item = { id: Number(btn.dataset.variantId), quantity: 1 };
    if (btn.dataset.sellingPlan) item.selling_plan = Number(btn.dataset.sellingPlan);

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    post(cartUrl + '/clear.js')
      .then(function () {
        return post(addUrl + '.js', { items: [item] });
      })
      .then(function () {
        if (btn.dataset.discount) {
          window.location.href = '/discount/' + encodeURIComponent(btn.dataset.discount) + '?redirect=%2Fcheckout';
        } else {
          window.location.href = '/checkout';
        }
      })
      .catch(function () {
        delete btn.dataset.etBuyBusy;
        if (btn.href) window.location.href = btn.href;
      });
  });
})();
